export function ChooseSubscriberController(
    $stateParams,
    $window,
    Notify,
    BdLocalize,
    PublicAuthenticationApi, 
    subscribersToChoose,
    RedirectToLoginService
) {
    const vm = this;
    
    vm.subscriberPickerModalTitleText = BdLocalize.getString('Public.Login.SubscriberPicker.ChooseSubscriber.Title', 
        'Select an account');
    vm.subscriberPickerBodyText = BdLocalize.getString('Public.Login.SubscriberPicker.ChooseSubscriber.Body', 
        'You have multiple accounts for this email address.');
    vm.isSubscriberPickerVisible = true;

    function initialize() {        
        if (subscribersToChoose.success) {
            for (let x = 0; x < subscribersToChoose.data.length; x++) {
                subscribersToChoose.data[x].UserId = x;
            }
            vm.subscribersToChoose = subscribersToChoose.data;            
        } else if (subscribersToChoose.errorCode === 226) {
            vm.isSubscriberPickerVisible = false;
            // If the token is invalid we send the user back to the login page.
            RedirectToLoginService.redirect();
        }
    }

    vm.loginSelectedSubscriber = function loginSelectedSubscriber(subscriber) {
        const request = {
            IsAdmin: subscriber.IsAdmin,
            IsReadOnly: subscriber.IsReadOnly,
            ReturnUrl: $stateParams.returnUrl || $stateParams.ReturnUrl,      
            IdToken: $stateParams.token,
            Provider: $stateParams.provider
        };
        
        PublicAuthenticationApi.loginSubscriberFromThirdParty(request)
            .then(response => {
                if (response.RedirectUrl) {
                    $window.location.assign(response.RedirectUrl);
                }
            })
            .catch(error => {                
                if (error.status === 422 && parseInt(error.data.ErrorCode, 10) === 226) {
                    // If the token is invalid we send the user back to the login page.
                    RedirectToLoginService.redirect();
                }
            });
    };

    initialize();
}

ChooseSubscriberController.$inject = [
    '$stateParams', 
    '$window', 
    'Notify',
    'BdLocalize',
    'PublicAuthenticationApi', 
    'subscribersToChoose',
    'RedirectToLoginService'
];
